import imageUrls from '../images/imageUrls';
import { ErrorKey } from './ErrorKey';
import StandardError from './StandardError';
import { jsx as _jsx } from "react/jsx-runtime";
const SessionExpiredErrorView = () => {
  return /*#__PURE__*/_jsx(StandardError, {
    errorKey: ErrorKey.SessionExpired,
    imageURL: imageUrls.clock
  });
};
export default SessionExpiredErrorView;